import React from "react";

const defaultFinancialEffectsData = [
  {
    sno: 1,
    riskOrOpportunityFE: "",
    effectsFinancialPosition: "",
    effectsFinancialPerformance: "",
    effectsCashFlows: "",
    significantRiskMaterialAdjustment: "",
  },
];

const FinancialEffectsRiskTable = ({
  financialEffectsData,
  setFinancialEffectsData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...financialEffectsData];
    updated[index][field] = value;
    setFinancialEffectsData(updated);
  };
  const renumberRows = (arr) => arr.map((r, i) => ({ ...r, sno: i + 1 }));

  const addRow = () =>
    setFinancialEffectsData([
      ...financialEffectsData,
      {
        sno: (financialEffectsData?.length || 0) + 1,
        riskOrOpportunityFE: "",
        effectsFinancialPosition: "",
        effectsFinancialPerformance: "",
        effectsCashFlows: "",
        significantRiskMaterialAdjustment: "",
      },
    ]);

  const removeRow = () => {
    if (financialEffectsData.length > 1) {
      setFinancialEffectsData(renumberRows(financialEffectsData.slice(0, -1)));
    }
  };

  // remove per-cell borders; outer frame + inner grid will handle perfect corners
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const textAreaStyle = {
    ...inputStyle,
    minHeight: "70px",
    resize: "vertical",
  };

  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      {/* table frame + perfect corners */}
      <style>{`
        .feTableFrame{
          border: 1px solid #000;
          border-radius: 8px;
          overflow: hidden;
        }
        .feTable{
          width: 100%;
          border-collapse: collapse;
        }
        .feTable th,
        .feTable td{
          border: 1px solid #000;   /* inner grid lines */
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .feTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide outer edges; frame draws outside border */
        .feTable thead tr:first-child th{ border-top: 0; }
        .feTable tr th:first-child,
        .feTable tr td:first-child{ border-left: 0; }
        .feTable tr th:last-child,
        .feTable tr td:last-child{ border-right: 0; }
        .feTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <div className="feTableFrame">
        <table className="feTable">
          <thead>
            <tr>
              <th style={{ ...header, width: 70 }}>S.NO.</th>
              <th style={header}>Risk/Opportunity</th>
              <th style={header}>Effects on entity’s financial position</th>
              <th style={header}>Effects on entity’s financial performance</th>
              <th style={header}>Effects on entity’s cash flows</th>
              <th style={header}>
                Significant risk of a material adjustment to the carrying
                amounts of assets and liabilities in the next annual reporting
                period?
              </th>
            </tr>
          </thead>

          <tbody>
            {financialEffectsData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{index + 1}.</td>

                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.riskOrOpportunityFE}
                    onChange={(e) =>
                      handleChange(index, "riskOrOpportunityFE", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.effectsFinancialPosition}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "effectsFinancialPosition",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.effectsFinancialPerformance}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "effectsFinancialPerformance",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.effectsCashFlows}
                    onChange={(e) =>
                      handleChange(index, "effectsCashFlows", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <select
                    value={row.significantRiskMaterialAdjustment}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "significantRiskMaterialAdjustment",
                        e.target.value
                      )
                    }
                    style={inputStyle}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Unknown">Unknown</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 10,
          gap: 10,
        }}
      >
        <button onClick={removeRow} style={buttonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={buttonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default FinancialEffectsRiskTable;
